export const MODALS = {
  savePointModal: "SAVE_POINT_MODAL",
  detectedFieldDetailsModal: "DETECTED_FIELD_DETAILS_MODAL",
};

export const POINTER_MODES = {
  POSITION: 0,
  SELECTION: 1,
};

export const SETTING_DEFAULT_COLORS = {
  DRAWING_OBJECT: "#EB1D36",
  CURRENT_OBJECT: "#0A663B",
  DETECTED_FIELD: "#FFDE00",
};
